import FJAiVideoDubLeftContainer from './FJAiVideoDubLeft/container/FJAiVideoDubLeftContainer';
import FJAiVideoDubRightContainer from './FJAiVideoDubRight/container/FJAiVideoDubRightContainer';
import FJCodecStore from '../../store/FJCodecStore';
import { useEffect } from 'react';
import FJActionAiVideoDub from '../../redux/action/FJActionAiVideoDub';
import { useDispatch } from 'react-redux';

const FJAiVideoDub = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        FJCodecStore.init();
        dispatch(FJActionAiVideoDub.initAIVideoDubAction());
    }, [dispatch]);

    return (
        <>
            <FJAiVideoDubLeftContainer />
            <FJAiVideoDubRightContainer />
        </>
    );
};

export default FJAiVideoDub;
